import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=de71921c&scoped=true"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=de71921c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de71921c",
  null
  
)

export default component.exports